export const CustomProjectStep2ElementsIdsEnum = {
    STEPS_NAVIGATE_HEADER: 'stepsNavigateHeader',
    WORK_AREA_STEP2_SECTION: 'workAreaStep2Section',
    WORK_AREA_STEP2_SWITCHER_BUTTON: 'workAreaStep2SectionButton',
    WORK_AREA_STEP2_MINIMUM_PRICE_BUTTON: 'workAreaStep2MinimumPriceButton',
    WORK_AREA_STEP2_FLUSH_BUTTON: 'workAreaStep2FlushButton',
    WORK_AREA_STEP2_SELECT_PRODUCT: 'workAreaStep2SelectProduct',
    WORK_AREA_STEP2_SAVE_PRODUCTS_BUTTON: 'workAreaStep2SaveProductsButton',
    WORK_AREA_STEP2_FOOTER: 'workAreaStep2Footer',
    STEP2_PAGE_EXPAND_BUTTON: 'step2PageExpandButton',
    TOTAL_PRICE_PAGE_STEP2_BLOCK_PDF_BUTTON:
        'totalPricePageStep2BlockPDFButton',
    TOTAL_PRICE_PAGE_STEP2_BLOCK_SELECT_PRODUCT_BUTTON:
        'totalPricePageStep2BlockSelectProductButton',
    TOTAL_PRICE_PAGE_STEP2_BLOCK_SAVE_PROJECT_BUTTON:
        'totalPricePageStep2BlockSaveProjectButton',
} as const;

export type CustomProjectStep2ElementsIdsType =
    (typeof CustomProjectStep2ElementsIdsEnum)[keyof typeof CustomProjectStep2ElementsIdsEnum];
